import { useEffect, useState } from 'react';
import { useApi, formatPrice } from '../../lib/api';

type Dispute = {
  dispute_id: string;
  order_id: string;
  reason: string;
  status: string;
  created_at: number;
  total_cents: number;
  order_status: string;
  buyer_email: string;
  seller_email: string;
  opponent: string;
  game_date: string;
};

export default function AdminDisputes() {
  const api = useApi();
  const [disputes, setDisputes] = useState<Dispute[]>([]);
  const [note, setNote] = useState<Record<string, string>>({});

  async function refresh() {
    const { disputes } = await api<{ disputes: Dispute[] }>('/admin/disputes?status=open');
    setDisputes(disputes);
  }
  useEffect(() => {
    refresh().catch(console.error);
  }, []);

  async function decide(id: string, action: 'refund' | 'release' | 'reject') {
    await api(`/admin/disputes/${id}`, {
      method: 'PATCH',
      body: JSON.stringify({ action, resolution: note[id] ?? '' }),
    });
    await refresh();
  }

  return (
    <section>
      <h2>Disputes</h2>
      {disputes.length === 0 && <p className="muted">No open disputes.</p>}
      <div className="grid cols-3">
        {disputes.map((d) => (
          <div className="card" key={d.dispute_id}>
            <p>
              <strong>{d.opponent}</strong> — {d.game_date}
            </p>
            <p>
              <span className="badge">{d.order_status}</span>
            </p>
            <p className="price">{formatPrice(d.total_cents)}</p>
            <p>Buyer: {d.buyer_email}</p>
            <p>Seller: {d.seller_email}</p>
            <p className="muted">Reason: {d.reason}</p>
            <textarea
              placeholder="Resolution note"
              value={note[d.dispute_id] ?? ''}
              onChange={(e) => setNote({ ...note, [d.dispute_id]: e.target.value })}
            />
            <div style={{ display: 'flex', gap: '0.5rem', marginTop: '0.5rem', flexWrap: 'wrap' }}>
              <button onClick={() => decide(d.dispute_id, 'refund')}>Refund buyer</button>
              <button className="btn-secondary" onClick={() => decide(d.dispute_id, 'release')}>
                Release to seller
              </button>
              <button className="btn-secondary" onClick={() => decide(d.dispute_id, 'reject')}>
                Reject claim
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
